import React from 'react';

import { useAppSelector } from 'src/store/reducers';

import type { TopMessageProps } from './TopMessageComponent';

import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';

import { getNotificationPanelContent } from './getContent';
import { ReplaceLinks } from '../navigator/replaceLinks';

export const RenderNotificationPanelMessage = (props: TopMessageProps): React.JSX.Element | null => {
  const { resources, openSidebar } = props;
  const { isMicroweb } = useAppSelector(state => state.microweb);
  const content = getNotificationPanelContent(props, isMicroweb);
  if (!content) return null;

  const { message, variant, testId } = content;

  return (
    <NotificationPanel testId={testId} variant={variant} className="notication-panel">
      <ReplaceLinks messageText={message} resources={resources} openSidebar={openSidebar} />
    </NotificationPanel>
  );
};
